import { RequestType } from '../types/transport/external/api-clients/google';
export const gameLibrary = [
    {
        gameCore: {
            gameId: '6701bc6c35797c2928318643',
            gameName: "Finish Each Other's Sandwiches",
            gameDescription: `Seeking all psychics! Prove you and your crew are in sync.\n\nWork together to climb the scoreboard and impress the Sandwich Spirits by matching answers across four rounds: Quick Bites, Snack Attack, Same Order, and The Whole Enchilada. Each round has its own twist, but the goal stays the same: the more your minds align, the more points you earn.\n\nEvery now and then, you'll swear someone reached into your brain and finished your… sandwich.`,
            gameAbstract: 'A sandwich-themed collaborative game where players prove they are psychically in sync by matching answers.',
            gamePlayersMin: 2,
            gamePlayersMax: 16,
            gameTotalTurns: 4,
            isTeamGame: true,
            teamCount: 1,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-10-26'),
            gameType: 'Cooperative',
            gameMechanics: ['Free Input', 'Selection', 'Deduction'],
            averageDuration: 17,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1361750505600319538',
        },
    },
    {
        gameCore: {
            gameId: '68016cb23f0914bff706b7ca',
            gameName: 'Ego Maniacs',
            gameDescription: `Each round, a fresh batch of Ego Awards gets conjured up—but plot twist: there aren't enough trophies for everyone. Players vote on who deserves each award the most. Of course you can vote for yourself, you magnificent narcissist.\n\nSnag an award and you're safe. Fail to impress? One unlucky soul gets the boot. Eliminated players still get to vote, so don't get too comfortable. The last player left standing is crowned the biggest Ego Maniac and gets to bask in the very accurate belief that they're better than everyone else.`,
            gameAbstract: `An elimination game where players vote on awards for each other and themselves; fail to win one each round and you're out.`,
            gamePlayersMin: 4,
            gamePlayersMax: 8,
            gameTotalTurns: 0, // Dynamic based on player count (players - 1)
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-10-10'),
            gameType: 'Free-For-All',
            gameMechanics: ['Voting', 'Elimination'],
            averageDuration: 13,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1361750539590963221',
        },
        imageGenerationConfig: {
            imageRequestType: RequestType.TROPHY_IMAGE,
            descriptionRequestType: RequestType.TROPHY_IMAGE_DESCRIPTION,
            bucketName: 'game-assets-ego-maniacs',
            fallbackImage: 'images/fallbacks/trophy_generic_golden.png',
        },
    },
    {
        gameCore: {
            gameId: '67d1c7c8d303f4b1017260a4',
            gameName: 'Meme Mash',
            gameDescription: `Each round starts with a blank meme template. Everyone fills it in with their best, most original answers. Then it's remix time: sift through the wild pile of responses to find the hidden gems and rebuild the meme.\n\nYou earn points every time someone uses your answer in a remix. At the end, the player with the most points earns the title of Supreme Meme Lord—and all the pretend power that comes with it.`,
            gameAbstract: "Players fill in ad-lib style meme templates, remix each other's answers, and earn points when their answers are used.",
            gamePlayersMin: 3,
            gamePlayersMax: 12,
            gameTotalTurns: 4,
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-09-23'),
            gameType: 'Free-For-All',
            gameMechanics: ['Free Input', 'Selection', 'Voting'],
            averageDuration: 18,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1361750566249697372',
        },
        imageGenerationConfig: {
            imageRequestType: RequestType.MEME_IMAGE,
            descriptionRequestType: RequestType.MEME_IMAGE_DESCRIPTION,
            bucketName: 'game-assets-meme-mash',
            fallbackImage: 'images/fallbacks/meme_not_found.png',
        },
    },
    {
        gameCore: {
            gameId: '68eb1f40d63530c3bfd356e6',
            gameName: 'WTF Is Happening',
            gameDescription: `Players are freelance reporters at a struggling newspaper, The Airhead Times. Each round, you'll get a theme and a random three-letter acronym to pitch the perfect headline to Poppy, the Editor-in-Chief.\n\nYou won't have much time to make journalistic magic before the deadline. The room votes on the headline with the most potential, and Poppy runs the story. Land the funniest, fastest headlines to earn points and rise through the ranks of the newsroom.\n\nIt's newsroom nonsense meets acronym anarchy. Good luck making sense of WTF Is Happening.`,
            gameAbstract: 'Players craft newspaper headlines using random three-letter acronyms. Points are earned when headlines are submitted quickly or receive votes.',
            gamePlayersMin: 3,
            gamePlayersMax: 12,
            gameTotalTurns: 4,
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-10-16'),
            gameType: 'Free-For-All',
            gameMechanics: ['Free Input', 'Selection', 'Voting'],
            averageDuration: 17,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1428483927961501806',
        },
        imageGenerationConfig: {
            imageRequestType: RequestType.NEWSPAPER_IMAGE,
            bucketName: 'game-assets-wtf-is-happening',
            fallbackImage: 'images/fallbacks/balloon_bunch_grayscale.png',
        },
    },
    {
        gameCore: {
            gameId: '6921e33b0eef394c89845fb8',
            gameName: 'Second Opinions',
            gameDescription: `Poppy is in trouble and headed into surgery. Good Doctors work together to heal our beloved patient, while Bad Doctors secretly try to push Poppy toward the great beyond. \n\n Each turn, the Chief of Medicine and their Committee select a HEAL or HURT treatment. The group can accuse suspicious doctors of malpractice and eliminate them from the game. \n\n Good Doctors win by fully healing Poppy or eliminating all Bad Doctors. If Poppy flatlines or all Good Doctors are eliminated, Bad Doctors win and we all lose a bit of faith in the medical system.`,
            gameAbstract: 'A deception hidden-role game where Good Doctors try to heal Poppy while Bad Doctors try to hurt. Doctors suspected of malpractice can be voted out.',
            gamePlayersMin: 5,
            gamePlayersMax: 16,
            gameTotalTurns: 999, // Artificially high since win conditions are determined by score & elimination
            isTeamGame: true,
            teamCount: 2,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-12-04'),
            gameType: 'Team',
            gameMechanics: ['Selection', 'Voting', 'Deduction', 'Elimination'],
            averageDuration: 20,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1446205781543358655',
        },
    },
    {
        gameCore: {
            gameId: '693bad642f3a8ff742190144',
            gameName: 'Quinspire',
            gameDescription: `Reach for the clouds in this twist on classic hangman. A player picks a theme, then five mystery words stack into a pyramid. Guess letters one by one to uncover all five words at once.\n\nCorrect letters score points. Finish a word for a bonus. Guess wrong? You're locked out while everyone else keeps climbing.\n\nMost points after all rounds wins. Think you can hang?`,
            gameAbstract: 'A word-guessing game where players reveal five themed words at once by guessing letters.',
            gamePlayersMin: 1,
            gamePlayersMax: 6,
            gameTotalTurns: 4,
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2025-12-18'),
            gameType: 'Free-For-All',
            gameMechanics: ['Selection'],
            averageDuration: 11,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1451363002522669296',
        },
    },
    {
        gameCore: {
            gameId: '6944abab5d2f2d3fde971460',
            gameName: 'Too Many Cooks',
            gameDescription: `Step into a chaotic kitchen where every chef thinks they're the star.\n\nYou'll create three courses. The Chef Survey stocks the pantry with the ingredients you need to craft each of your world-class dishes.\n\nScore points when your ingredients are used and even more when your dishes win votes. Only the most elite culinary masters will rise to the top in a kitchen with Too Many Cooks.`,
            gameAbstract: 'Players create dishes from shared ingredients and vote on the best. Points earned when your ingredients get used or your dishes win votes.',
            gamePlayersMin: 3,
            gamePlayersMax: 10,
            gameTotalTurns: 6,
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-01-06'),
            gameType: 'Free-For-All',
            gameMechanics: ['Free Input', 'Selection', 'Voting'],
            averageDuration: 17,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1458293853810327573',
        },
        imageGenerationConfig: {
            imageRequestType: RequestType.BEST_DISH_IMAGE,
            descriptionRequestType: RequestType.BEST_DISH_IMAGE_DESCRIPTION,
            bucketName: 'game-assets-too-many-cooks',
            fallbackImage: 'images/fallbacks/empty_plate.png',
        },
    },
    {
        gameCore: {
            gameId: '69ac5a4510c9adc947dc1981',
            gameName: 'Bad Bunnies',
            gameDescription: 'The bunnies have launched a fluffy coup, and every burrow is a ticking fur-bomb. Each turn, every burrow with at least two bunnies spawns more bunnies into adjoining burrows, and the map gets messier fast.\n\nYour squad votes on how to respond: destroy tunnels, cull colonies, or distract them with food before the swarm snowballs out of control. Wipe out every last bunny to win. Let the population hit 1,000 and the rabbits claim the planet.',
            gameAbstract: 'A co-op game where players vote on tactical actions to stop runaway bunny reproduction before the population grows too large.',
            gamePlayersMin: 1,
            gamePlayersMax: 16,
            gameTotalTurns: 999,
            isTeamGame: true,
            teamCount: 1,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-03-25'),
            gameType: 'Cooperative',
            gameMechanics: ['Selection', 'Voting'],
            averageDuration: 15,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1486420856526606508',
        },
    },
    {
        gameCore: {
            gameId: '69c55319c9763aa207ae0fb2',
            gameName: 'Feed The Farm',
            gameDescription: `Welcome to the filthiest farm on the internet. In this rapid-fire game, players choose one of three mystery cards or sit out for the round.\n\nThe mystery cards are full of good food to plump your animal and score up, but some delicacies will shrink you back down. Chaos cards cause mayhem. Crap cards completely wipe your score to zero and leave behind a permanent poop monument of shame.\n\nThe first of you nasty little animals to reach 100 points wins.`,
            gameAbstract: 'Players race to 100 points by picking mystery cards to feed their farm animal. Good, Bad, Chaos, and Crap cards have different effects on scores.',
            gamePlayersMin: 2,
            gamePlayersMax: 16,
            gameTotalTurns: 999, // Artificially high since the game ends on the score race to 100
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-04-04'),
            gameType: 'Free-For-All',
            gameMechanics: ['Selection'],
            averageDuration: 10,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1490124183286448149',
        },
    },
    {
        gameCore: {
            gameId: '6a3349523db03ba5ecbf1db2',
            gameName: 'Okie Dokie',
            gameDescription: `Welcome to the Bureau of Okie Dokie, Airhead County's department for approving absolutely everything.\n\nPlayers first build the day's docket of cases, then help complete the paperwork before stamping their favorite answers to be officially filed.\n\nAt the end of the day, the bureau closes with a memo recommending what Airhead County should do about a single filing from the day's caseload. In true government fashion, everything else will be pending indefinitely.\n\nMost points wins the honor every civil servant dreams of: Airhead County's Okayest Bureaucrat.`,
            gameAbstract: "Players submit case themes, write and approve bureau paperwork, then cap the day with a memo making a recommendation on one of the day's most pressing issues.",
            gamePlayersMin: 3,
            gamePlayersMax: 8,
            gameTotalTurns: 5,
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-06-30'),
            gameType: 'Free-For-All',
            gameMechanics: ['Free Input', 'Selection', 'Voting'],
            averageDuration: 18,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1521601660852637726',
        },
    },
    {
        gameCore: {
            gameId: '6a4443ab95150cffae4f482e',
            gameName: 'Wild Things',
            gameDescription: `We're going on a nature expedition, and something weird is moving in the brush.\n\nFirst, the group suggests what they think they saw. Next, the group sketches the specimen together with each player handling one segment of the artwork. When the sketches are done, the group rightfully gets to name the new species they discovered.\n\nFinally, once you're close enough, you will get a real glimpse of the wild thing that awaits you. No points up for grabs, just collective pride in furthering humanity's understanding of nature.`,
            gameAbstract: `A cooperative drawing game: suggest a sighting, sketch it in shared segments, name the species, then unveil the real wild thing beside the group's art.`,
            gamePlayersMin: 2,
            gamePlayersMax: 16,
            // Three full specimens of WILD_THINGS_TURNS_PER_SPECIMEN turns each
            gameTotalTurns: 12,
            // Team count depends on the final player count (ceil(N/4)), so teams
            // are formed by the recipe at game start rather than at room creation
            // (teamCount is intentionally omitted).
            isTeamGame: true,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-07-11'),
            gameType: 'Cooperative',
            gameMechanics: ['Free Input', 'Selection', 'Voting', 'Drawing'],
            averageDuration: 18,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1525728691491962930',
        },
        imageGenerationConfig: {
            imageRequestType: RequestType.WILD_THING_IMAGE,
            bucketName: 'game-assets-wild-things',
            fallbackImage: 'images/fallbacks/wild_things_unknown_specimen.png',
        },
    },
    {
        gameCore: {
            gameId: '6a4445679a8400bf1b9aae8d',
            gameName: 'Wanted',
            gameDescription: `The sheriff needs help catching some truly heinous criminals.\n\nEach round, one player secretly pairs a suspect with an absurd crime and draws it live on a WANTED poster. Everyone else plays detective, racing to identify the suspect from the sketch. Faster correct guesses earn more points, and the artist scores every time a detective cracks the case.\n\nOnce the suspect is revealed, the whole precinct files a charge, picking the real crime from a lineup of look-alikes to earn extra points. Score the most in this free-for-all to prove you're one of Airhead's finest officers.`,
            gameAbstract: 'Artists sketch secret suspects on wanted posters while detectives race to ID them for speed-based points, then everyone files the charge from decoy look-alikes.',
            gamePlayersMin: 3,
            gamePlayersMax: 8,
            gameTotalTurns: 0, // Dynamic: one turn per player, capped at 8
            isTeamGame: false,
            loonCost: 1,
        },
        gameWiki: {
            releasedAt: new Date('2026-07-11'),
            gameType: 'Free-For-All',
            gameMechanics: [
                'Drawing',
                'Deduction',
                'Free Input',
                'Selection',
                'Voting',
            ],
            averageDuration: 20,
            discordChannel: 'https://discord.com/channels/1361741144521838622/1525728753538433096',
        },
        // Wanted has no AI image generation; this bucket stores the players'
        // saved wanted-poster sketches.
        assetBucketName: 'game-assets-wanted',
    },
];
//# sourceMappingURL=gameLibrary.js.map